<template>
  <table class="table placeholder-glow table-nowrap">
    <thead>
      <tr>
        <th class="text-start" style="width: 20px">
          <span class="placeholder" style="width: 20px; height: 10px"></span>
        </th>
        <th>
          <span class="placeholder col-10 rounded"></span>
        </th>
        <th>
          <span class="placeholder col-12 rounded"></span>
        </th>
        <th>
          <span class="placeholder col-12 rounded"></span>
        </th>
        <th>
          <span class="placeholder col-12 rounded"></span>
        </th>
        <th v-if="ldata != null && ldata.role == 'super_admin'">
          <span class="placeholder col-10 rounded"></span>
        </th>
        <th>
          <span class="placeholder col-10 rounded"></span>
        </th>
        <th>
          <span class="placeholder col-6 rounded"></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="n in 7" :key="n">
        <td class="text-start" style="width: 20px">
          <span class="placeholder" style="width: 20px; height: 10px"></span>
        </td>
        <td class="text-center">
          <span class="placeholder placeholder-sm col-8 rounded"></span>
        </td>
        <td>
          <span class="placeholder placeholder-sm col-10 rounded"></span>
        </td>
        <td>
          <span class="placeholder placeholder-sm col-10 rounded"></span>
        </td>
        <td>
          <span class="placeholder placeholder-sm col-12 rounded"></span>
        </td>
       
        <td>
          <span class="placeholder placeholder-sm col-6 rounded"></span>
        </td>
        <td>
          <div>
            <span class="placeholder placeholder-sm col-1 me-2 rounded"></span>
            <span class="placeholder placeholder-sm col-1 rounded"></span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
    name:"loadingTable"
}
</script>